<template>
  <b-modal
    id="register-modal"
    modal-class="ts-auth-modal ts-register-modal"
    dialog-class="modal-dialog-centered modal-dialog-scrollable"
    header-class="border-0 p-4 pb-0 mb-3"
    body-class="px-4 pb-4 pt-0"
    hide-footer
    aria-labelledby="registerModalTitle"
    @show="onShow"
    @hidden="onHidden"
  >
    <template #modal-header="{ close }">
      <h2 id="registerModalTitle" class="modal-title ts-auth-title fw-bold">{{ translations[14405] }}</h2>
      <button class="btn-close" type="button" :aria-label="closeLabel" @click="close()"></button>
    </template>

    <div class="ts-role-switch ts-register-role-switch d-flex gap-1 rounded-pill p-1 w-100">
      <template v-for="item in roleOptions">
        <input
          :id="`registerRole-${item.value}`"
          :key="`input-${item.value}`"
          v-model="role"
          class="btn-check"
          type="radio"
          name="registerRole"
          :value="item.value"
        />
        <label
          :key="`label-${item.value}`"
          class="ts-role-option d-flex align-items-center justify-content-center text-center"
          :for="`registerRole-${item.value}`"
        >
          <i class="bi" :class="item.icon" aria-hidden="true"></i>
          {{ item.title }}
        </label>
      </template>
    </div>

    <!-- The forms keep their per-site field configuration (RegistrationFieldsMixin), captcha and success states -->
    <register-applicant-form v-if="role === roles.applicant" ref="form" @submit="submit" @registered="registered = true" />
    <register-company-form v-else ref="form" @submit="submit" @registered="registered = true" />

    <!-- After a successful registration the form shows its own confirmation instead -->
    <button
      v-if="!registered"
      id="register-account-btn"
      class="btn btn-primary w-100 fw-bold mt-3"
      type="button"
      :data-active-tab="`${role}-register-tab`"
      @click="submit"
    >
      {{ translations[13732] }}
    </button>

    <div v-if="!registered" class="ts-register-footer text-center small mt-3">
      <span>{{ translations[13733] }}</span>
      {{ ' ' }}<a href="#" @click.prevent="openLogin">{{ translations[13726] }}</a>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import RegisterApplicantForm from '@/components/Authorization/RegisterForms/RegisterApplicantForm.vue';
import RegisterCompanyForm from '@/components/Authorization/RegisterForms/RegisterCompanyForm.vue';
import { AppModule, AuthTab } from '@/store/modules/app';

type RegisterRole = AuthTab.applicant | AuthTab.firm;

interface RegisterForm extends Vue {
  onRegistration: () => void
}

@Component({
  components: { RegisterApplicantForm, RegisterCompanyForm },
})
export default class RegisterModal extends Vue {
  roles = { applicant: AuthTab.applicant, firm: AuthTab.firm } as const;

  role: RegisterRole = AuthTab.applicant;

  registered = false;

  get translations() {
    return AppModule.translation;
  }

  get closeLabel() {
    return AppModule.translation[2511];
  }

  get roleOptions() {
    return [
      { value: AuthTab.applicant, icon: 'bi-person', title: this.translations[11115] },
      { value: AuthTab.firm, icon: 'bi-building', title: this.translations[13937] },
    ];
  }

  // Opened for a specific role (?auth=f-registration, "register as employer" card) → preselect it
  onShow() {
    this.role = AppModule.selectedAuthTab === AuthTab.firm ? AuthTab.firm : AuthTab.applicant;
    this.registered = false;
  }

  onHidden() {
    AppModule.SET_SELECTED_AUTH_TAB(AuthTab.default);
  }

  submit() {
    (this.$refs.form as RegisterForm | undefined)?.onRegistration();
  }

  openLogin() {
    this.$bvModal.hide('register-modal');
    this.$bvModal.show('login-modal');
  }
}
</script>
